// Yoonly NL overrides — only keys that differ from the regular NL translations.
// Missing keys automatically fall back to the standard 'nl' locale, then 'fr'.

const commonYoonlyNlTranslations: any = {
    "contacts": {
        "logInOrRegister": "Log in of registreer om te boeken"
    },
    "confirmation": {
        "confirmationQuote1": "Yoonly bedankt voor uw vertrouwen en is blij om u te kunnen bevestigen dat uw zoekopdracht is opgeslagen.",
        "confirmationReservation8": "Je vindt al deze informatie in je Yoonly-account. Om in te loggen",
        "confirmationFindAnotherSearch2": "",
        "confirmationOtherPaymentMethod": "+32 2 808 25 70",
        "confirmationErrorPhone": "+32 2 808 25 70",
        "confirmationMakeReservationPhone2": "+32 2 808 25 70",
        "confirmationFindAnotherQuestion1": "Bel een van onze experts vacatures op +32 2 808 25 70",
    }
};

export default commonYoonlyNlTranslations;
